export default function Acid() {
    return (
        <svg className="w-6 h-6 fill-none" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
            <line stroke="currentColor" x1="7.23" y1="1.5" x2="16.77" y2="1.5" />
            <path stroke="currentColor" d="M14.86,6.27V1.5H9.14V6.27L2.7,19.15a2.3,2.3,0,0,0-.25,1h0A2.32,2.32,0,0,0,4.77,22.5H19.23a2.32,2.32,0,0,0,2.32-2.32h0a2.3,2.3,0,0,0-.25-1Z" />
            <path stroke="currentColor" d="M6.89,10.76c5-2.17,5.31,1.9,10.42.41" />
            <line stroke="currentColor" x1="7.23" y1="18.68" x2="9.14" y2="18.68" />
            <line stroke="currentColor" x1="10.09" y1="14.86" x2="12" y2="14.86" />
            <line stroke="currentColor" x1="14.86" y1="16.77" x2="16.77" y2="16.77" />
        </svg>
    );
}